const initialState = {
  industries: JSON.parse(localStorage.getItem('industries')) ? JSON.parse(localStorage.getItem('industries')) : [],
  offerings: JSON.parse(localStorage.getItem('offerings')) ? JSON.parse(localStorage.getItem('offerings')) : [],
  subOfferings: JSON.parse(localStorage.getItem('subOfferings')) ? JSON.parse(localStorage.getItem('subOfferings')) : [],
  processes: JSON.parse(localStorage.getItem('processes')) ? JSON.parse(localStorage.getItem('processes')) : [],
  regions: JSON.parse(localStorage.getItem('regions')) ? JSON.parse(localStorage.getItem('regions')) : [],

  process: JSON.parse(localStorage.getItem('process')) ? JSON.parse(localStorage.getItem('process')) : {},
  processId: JSON.parse(localStorage.getItem('processId')) ? JSON.parse(localStorage.getItem('processId')) : null,
  regionId: JSON.parse(localStorage.getItem('regionId')) ? JSON.parse(localStorage.getItem('regionId')) : null,
  industryId: JSON.parse(localStorage.getItem('industryId')) ? JSON.parse(localStorage.getItem('industryId')) : null,

  activeIndustry: JSON.parse(localStorage.getItem('activeIndustry')) ? JSON.parse(localStorage.getItem('activeIndustry')) : null,
  activeOffering: JSON.parse(localStorage.getItem('activeOffering')) ? JSON.parse(localStorage.getItem('activeOffering')) : null,
  activeSubOffering: JSON.parse(localStorage.getItem('activeSubOffering')) ? JSON.parse(localStorage.getItem('activeSubOffering')) : null,
  activeProcess: JSON.parse(localStorage.getItem('activeProcess')) ? JSON.parse(localStorage.getItem('activeProcess')) : null,
  activeRegion: JSON.parse(localStorage.getItem('activeRegion')) ? JSON.parse(localStorage.getItem('activeRegion')) : null,

  industrySelected: JSON.parse(localStorage.getItem('industrySelected')) ? JSON.parse(localStorage.getItem('industrySelected')) : null,
  offeringSelected: JSON.parse(localStorage.getItem('offeringSelected')) ? JSON.parse(localStorage.getItem('offeringSelected')) : null,
  subOfferingSelected: JSON.parse(localStorage.getItem('subOfferingSelected')) ? JSON.parse(localStorage.getItem('subOfferingSelected')) : null,
  processSelected: JSON.parse(localStorage.getItem('processSelected')) ? JSON.parse(localStorage.getItem('processSelected')) : null,
  regionSelected: JSON.parse(localStorage.getItem('regionSelected')) ? JSON.parse(localStorage.getItem('regionSelected')) : null,
};


const filterReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'SET_PROCESS':
    return Object.assign({}, state, {
      processId: action.payload.processId,
    });
  case 'SET_REGION_ID':
    return Object.assign({}, state, {
      regionId: action.payload.regionId,
    });
  case 'SET_INDUSTRY_ID':
    return Object.assign({}, state, {
      industryId: action.payload.industryId,
    });
  case 'GET_INDUSTRIES':
    return Object.assign({}, state, {
      industries: action.payload.industries,
    });
  case 'GET_OFFERINGS':
    return Object.assign({}, state, {
      offerings: action.payload.offerings,
    });
  case 'GET_REGIONS':
    return Object.assign({}, state, {
      regions: action.payload.regions,
    });
  case 'RESET_FILTERS':
    return Object.assign({}, state, {
      industries: [],
      offerings: [],
      regions: [],
      subOfferings: [],
      processes: [],
      process: {},
      activeIndustry: null,
      activeOffering: null,
      activeSubOffering: null,
      activeProcess: null,
      activeRegion: null,
      industrySelected: null,
      offeringSelected: null,
      subOfferingSelected: null,
      processSelected: null,
      regionSelected: null,
    });
  case 'GET_SUB_OFFERINGS':
    return Object.assign({}, state, {
      subOfferings: action.payload.subOfferings,
    });
  case 'GET_PROCESSES':
    return Object.assign({}, state, {
      processes: action.payload.processes,
    });
  case 'SET_INDUSTRY_NAME':
    return Object.assign({}, state, {
      activeIndustry: action.payload.activeIndustry,
    });
  case 'SET_OFFERING_NAME':
    return Object.assign({}, state, {
      activeOffering: action.payload.activeOffering,
    });
  case 'SET_SUB_OFFERING_NAME':
    return Object.assign({}, state, {
      activeSubOffering: action.payload.activeSubOffering,
    });
  case 'SET_PROCESS_NAME':
    return Object.assign({}, state, {
      activeProcess: action.payload.activeProcess,
    });
  case 'SET_REGION_NAME':
    return Object.assign({}, state, {
      activeRegion: action.payload.activeRegion,
    });
  case 'SET_INDUSTRY_SELECTED':
    return Object.assign({}, state, {
      industrySelected: action.payload.industrySelected,
      offeringSelected: null,
      subOfferingSelected: null,
      processSelected: null,
      regionSelected: null,
    });
  case 'SET_OFFERING_SELECTED':
    return Object.assign({}, state, {
      offeringSelected: action.payload.offeringSelected,
      subOfferingSelected: null,
      processSelected: null,
      regionSelected: null,
    });
  case 'SET_SUB_OFFERING_SELECTED':
    return Object.assign({}, state, {
      subOfferingSelected: action.payload.subOfferingSelected,
      processSelected: null,
      regionSelected: null,
    });
  case 'SET_PROCESS_SELECTED':
    return Object.assign({}, state, {
      processSelected: action.payload.processSelected,
      regionSelected: null,
    });
  case 'SET_REGION_SELECTED':
    return Object.assign({}, state, {
      regionSelected: action.payload.regionSelected,
    });
  default:
    return state;
  }
};


export default filterReducer;
